import React from 'react';
import { Observable } from 'rxjs';
import { IMenuDTO, ISystemDTO } from 'src/components/types';

export interface SystemProps {
  getSystemConfig: () => ISystemDTO;
  setSystemConfig: (config: ISystemDTO) => void;
  getMenuConfig: (code: string) => IMenuDTO | undefined;
  getMenuConfigFromPath: (path: string) => IMenuDTO | undefined;
  watchSystemConfig: () => Observable<ISystemDTO>;
  watchSystemLoaded: () => Observable<boolean>;
}

const getBlankConfig = (): ISystemDTO => {
  return { menuGroups: [] } as ISystemDTO;
};

const createDefault = (): SystemProps => ({
  getSystemConfig: (): ISystemDTO => {
    console.warn('Ops likely you forgot to add the context provider on top of your app');
    return getBlankConfig();
  },

  setSystemConfig: (_config: ISystemDTO): void => {
    console.warn('Ops likely you forgot to add the context provider on top of your app');
  },

  getMenuConfig: (_code: string): IMenuDTO | undefined => {
    console.warn('Ops likely you forgot to add the context provider on top of your app');
    return undefined;
  },

  getMenuConfigFromPath: (_path: string): IMenuDTO | undefined => {
    console.warn('Ops likely you forgot to add the context provider on top of your app');
    return undefined;
  },

  watchSystemConfig: (): Observable<ISystemDTO> => {
    console.warn('Ops likely you forgot to add the context provider on top of your app');
    return new Observable<ISystemDTO>((observer) => {
      observer.next(getBlankConfig());
      observer.complete();
    });
  },

  watchSystemLoaded: (): Observable<boolean> => {
    console.warn('Ops likely you forgot to add the context provider on top of your app');
    return new Observable<boolean>((observer) => {
      observer.next(false);
      observer.complete();
    });
  },
});

export const SystemContext = React.createContext<SystemProps>(createDefault());
